// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"5d0d7151","147":"792c48a2","222":"792c48a2"}[chunkId] + ".chunk.css";
};